import { useLayoutEffect, useState, type ReactNode, type RefObject } from 'react';
import { createPortal } from 'react-dom';
export default function SelectedSalesActionDock({
  anchor,
  children,
}: {
  anchor: RefObject<HTMLDivElement>;
  children: ReactNode;
}) {
  const [bounds, setBounds] = useState<{ left: number; width: number } | null>(null);
  useLayoutEffect(() => {
    let frame = 0;
    const measure = () => {
      const rect = anchor.current?.getBoundingClientRect();
      if (!rect) return;
      const left = Math.max(8, rect.left);
      const width = Math.max(0, Math.min(innerWidth - 8, rect.right) - left);
      setBounds((old) => (old?.left === left && old?.width === width ? old : { left, width }));
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    };
    measure();
    const observer = new ResizeObserver(schedule);
    if (anchor.current) observer.observe(anchor.current);
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, true);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule, true);
    };
  }, [anchor]);
  if (!bounds) return null;
  return createPortal(
    <section
      aria-label="Selected sales actions"
      style={{ ...bounds, bottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)' }}
      className="fixed z-40 rounded-2xl border border-primary/30 bg-card p-3 shadow-2xl print:hidden"
    >
      {children}
    </section>,
    document.body,
  );
}
